import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { store } from "@root/store";
export var toggleEditorFullScreen = function toggleEditorFullScreen() {
    var storeState = store.getState();
    var session = storeState.ProjectEditorReducer;
    var tabIndex = session.tabDock.tabIndex;
    var editorInstance = session.tabDock.openDocuments[tabIndex].editorInstance;
    editorInstance.display.wrapper.requestFullscreen();
};
export var manualEntryAtPoint = function manualEntryAtPoint(editorReference) {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1)
                switch (_context.prev = _context.next) {
                    case 0:
                        console.log("FIXME", editorReference);
                    // if (!editorReference || !window.csoundSynopsis) {
                    //     return;
                    // }
                    // const cursor = editorReference.getCursor();
                    // const token = editorReference
                    //     .getTokenAt(cursor)
                    //     .string.replace(/:.*/, "");
                    // const manualEntry = window.csoundSynopsis.find(
                    //     (opc) => opc.opname === token
                    // );
                    // if (manualEntry) {
                    //     dispatch(lookupManualString());
                    //     setTimeout(() => dispatch(lookupManualString(manualEntry.id)), 10);
                    // }
                    case 1:
                    case "end":
                        return _context.stop();
                }
        }, _callee);
    }));
};
